import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HttpApis from "../services/HttpApis";
import { useDispatch } from "react-redux";
import { menuFailure, menuStart, menuSuccess } from "../redux/slices/menuSlice";
import { useLocation } from "react-router-dom";

const useSectionHook = () => {
  const [selectedSectionID, setSelectedSectionID] = useState(null);
  const [sectionData, setSectionData] = useState([]);
  const [error, setError] = useState(null);
  const [details, setDetails] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionClick = async (data, pathname) => {
    setSelectedSectionID(data);
    setError(null);
    try {
      const rawContent = data?.content || [];

      if (rawContent.length === 0) {
        setSectionData([]);
        return;
      }

      const normalizedContent = rawContent.map((item) => ({
        ...item,
        thumbnail_image: item.landscape || item.portrait,
        type:
          item.content_type === "Live Channel"
            ? "live"
            : item.type || "movie",
      }));

      const carouselData = normalizedContent.slice(0, 6);
      const galleryData = normalizedContent.slice(6);

      const formatted = [];

      if (carouselData.length > 0) {
        formatted.push({
          type: "Carousel",
          items: carouselData,
        });
      }

      if (galleryData.length > 0) {
        formatted.push({
          type: "Gallery",
          title: data.title || "More Content",
          items: galleryData,
        });
      }

      setSectionData(formatted);

      if (pathname) {
        navigate(pathname);
      }
    } catch (error) {
      setError(error.message);
      setSectionData([]);
    }
  };

  const handleDetails = async (slug) => {
    setShowDetails(true);
    setError(null);

    try {
      const response = await HttpApis.get(`client/v1/content/${slug}`);

      setDetails(response?.data?.data || null);

      navigate(`/details/${slug}`);

      window.scrollTo(0, 0);
    } catch (error) {
      console.error("❌ Error fetching details:", error);
      setError(error.message);
      setDetails(null);
    }
  };

  return {
    handleSectionClick,
    selectedSectionID,
    sectionData,
    handleDetails,
    showDetails,
    details,
    error,
  };
};

export default useSectionHook;
